import { QueryClient } from "@tanstack/react-query";

const handleRouteChange = (client: QueryClient, route: string = "") => {
  if (route.includes("item_request")) {
    client.invalidateQueries("stock_item_request").then();
  }
};

export default handleRouteChange;
